import bind from 'bind-decorator';

import { ImageFormat } from '@egr/xbox/utils/FileFormats';
import { ImageSize, getCanvasFromImageFile, canvasToBlob, scaleImageSize, getScaledImageRatio } from '@egr/xbox/utils/Image';
import { getScaledImageUrl } from '@egr/xbox/utils/Services';

const MaxImageWidth: number = 2024;
const MaxImageHeight: number = 2024;
const MaxImageSize: Readonly<ImageSize> = {
    width: MaxImageWidth,
    height: MaxImageHeight
};

type ReplyType<DataType> = [DataType, ImageSize, ImageFormat] | [null, null, null];

export class ImageScaleManager {
    @bind
    public async getBlobFromFile(file: File): Promise<ReplyType<Blob>> {
        const canvas: HTMLCanvasElement | undefined = await getCanvasFromImageFile(file, MaxImageWidth, MaxImageHeight);
        if (canvas != null) {
            const blob: Blob | null = await canvasToBlob(canvas, 'image/jpeg');
            if (blob != null) {
                return [blob, {width: canvas.width, height: canvas.height}, ImageFormat.JPG];
            }
        }

        return [null, null, null];
    }

    /**
     * returns a scaled down version of the specified image dimension if required
     */
    @bind
    public getImageDimension(size: ImageSize): ImageSize {
        const ratio: number = getScaledImageRatio(size, MaxImageSize);
        if (ratio >= 1) {
            return size;
        }

        return scaleImageSize(size, ratio);
    }

    @bind
    public getImageSrc(src: string, size: ImageSize): [string, ImageSize] {
        const ratio: number = getScaledImageRatio(size, MaxImageSize);
        if (ratio >= 1) {
            return [src, size];
        }

        return [
            getScaledImageUrl(MaxImageWidth, MaxImageHeight, src),
            scaleImageSize(size, ratio)
        ];
    }
}